import { render, staticRenderFns } from "./TagBar.vue?vue&type=template&id=5843c86d&scoped=true&"
import script from "./TagBar.vue?vue&type=script&lang=js&"
export * from "./TagBar.vue?vue&type=script&lang=js&"
import style0 from "./TagBar.vue?vue&type=style&index=0&id=5843c86d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5843c86d",
  null
  
)

export default component.exports